import React, { useState } from "react";
import {
  Alert,
  Box,
  Paper,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Stack,
  Chip
} from "@mui/material";
import { bakeStreetSquareLogo } from "../../common/component/constants";
import moment from "moment";
import { useParams } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import currency from "currency.js";
import bkstApi from "../../common/component/api";
import { isEmailValid } from "../../common/component/util";
import PhoneField from "../../common/component/PhoneField";

export default function BakerCustomers(props) {
  const { bakerId } = useParams();
  const { customers } = props;

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [type, setType] = useState("retail");
  const [emailCc, setEmailCc] = useState("");
  const [paymentTerms, setPaymentTerms] = useState("net0");

  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");

  const handleOpen = () => {
    setOpen(true);
  };

  const validate = () => {
    let arr = [];
    if (!isEmailValid(email)) {
      arr.push("First Name is missing");
    }

    return arr.join(", ");
  };

  const handleClose = () => {
    setOpen(false);
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhone("");
    setType("");
    setEmailCc("");
    setPaymentTerms("");
  };

  const saveCustomer = () => {
    if (validate()) {
      setError(validate());
      return;
    }
    let customer = {
      firstName,
      lastName,
      email,
      phone
    };

    if (type === "commercial") {
      customer.type = "commercial";
      customer.emailCc = emailCc;
      customer.paymentTerms = paymentTerms;
    }

    bkstApi
      .post(`/admin/site/${bakerId}/customer`, { customer })
      .then((res) => {
        props.onChange(res.data.customer);
        handleClose();
      })
      .catch((err) => {
        setError(err.response.data.message);
      });
  };

  return (
    <Box p={2}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h5">{customers.length} Customers</Typography>
        <Button variant="outlined" color="primary" onClick={handleOpen}>
          Add Customer
        </Button>
      </Box>
      {customers
        .sort((o1, o2) => +(o2.spend || 0) - +(o1.spend || 0))
        .map((o) => {
          return (
            <Box my={2} sx={{ backgroundColor: "#FFF" }}>
              <Paper elevation={0} component={RouterLink} to={`/site/${bakerId}/customer/${o.id}`} sx={{ textDecoration: "none" }}>
                <Box p={2}>
                  <Typography variant="h6">
                    {o.firstName} {o.lastName} {o.type === "commercial" && <Chip size="small" label={`commercial / ${o.paymentTerms}`} color="info" />}{" "}
                    {o.src === "mkt" && <img src={bakeStreetSquareLogo} style={{ width: "24px", height: "24px" }} />}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    since {moment(o.created).format("MMM, YYYY")}
                  </Typography>
                  <Typography variant="body2">
                    {o.phone} {o.email || ""} {o.emailCc || ""}
                  </Typography>
                  <Typography variant="body2">{currency(o.spend).format()} spend</Typography>
                  {o.summary && (
                    <Typography variant="overline">
                      ORDERS: {o.summary.orders.future} FUTURE · {o.summary.orders.past} PAST | QUOTES: {o.summary.quotes.future} FUTURE ·{" "}
                      {o.summary.quotes.past} PAST
                    </Typography>
                  )}
                </Box>
              </Paper>
            </Box>
          );
        })}

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Add Customer</DialogTitle>
        <DialogContent>
          <Stack spacing={3} sx={{ mt: 2 }}>
            <Box sx={{ display: "flex", gap: 2, flexDirection: { xs: "column", sm: "row" } }}>
              <TextField label="First Name" value={firstName} onChange={(event) => setFirstName(event.target.value)} fullWidth required />
              <TextField label="Last Name" value={lastName} onChange={(event) => setLastName(event.target.value)} fullWidth required />
            </Box>
            <TextField label="Email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} fullWidth required />
            <PhoneField name="Phone" value={phone} onChange={(phone) => setPhone(phone)} required />

            <TextField label="Type" select value={type} onChange={(event) => setType(event.target.value)} fullWidth required>
              <MenuItem value="">Retail</MenuItem>
              <MenuItem value="commercial">Commercial</MenuItem>
            </TextField>
            {type === "commercial" && (
              <>
                <TextField
                  label="Email CC"
                  type="email"
                  value={emailCc}
                  onChange={(event) => setEmailCc(event.target.value)}
                  fullWidth
                  helperText="Add comma separated emails"
                />
                <TextField
                  label="Payment Terms"
                  select
                  value={paymentTerms}
                  onChange={(event) => setPaymentTerms(event.target.value)}
                  fullWidth
                  required
                >
                  <MenuItem key="net0" value="net0">
                    Net 0
                  </MenuItem>
                  <MenuItem key="net7" value="net7">
                    Net 7
                  </MenuItem>
                  <MenuItem key="net14" value="net14">
                    Net 14
                  </MenuItem>
                  <MenuItem key="net30" value="net30">
                    Net 30
                  </MenuItem>
                </TextField>
              </>
            )}
          </Stack>
          {error && (
            <Box mt={2}>
              <Alert severity="error">{error}</Alert>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="inherit">
            Cancel
          </Button>
          <Button onClick={saveCustomer} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
